import { render, staticRenderFns } from "./SignatureCanvas.vue?vue&type=template&id=c97cd8ac&scoped=true"
import script from "./SignatureCanvas.vue?vue&type=script&lang=js"
export * from "./SignatureCanvas.vue?vue&type=script&lang=js"
import style0 from "./SignatureCanvas.vue?vue&type=style&index=0&id=c97cd8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97cd8ac",
  null
  
)

export default component.exports